export const securityKeys = {
  root: ['security'] as const,
  externalLinks: () => [...securityKeys.root, 'externalLinks'] as const,
  modules: () => [...securityKeys.root, 'modules'] as const,
};
